import { Flex, Text } from '@mantine/core';

function SuccessFooter({ t }: any) {
  return (
    <Flex w={'100%'} justify={'center'} mt={40} mb={20} pt={8} style={{ borderTop: '1px solid #33334366' }}>
      <Text style={{ fontSize: 13 }}>{t('footer.success')}</Text>
    </Flex>
  )
}

export default SuccessFooter;